import { AmplifyConfig } from '@config/aws';
import Amplify, { Auth, Hub } from 'aws-amplify';

Amplify.configure(AmplifyConfig);

export { Auth, Hub };
